export const FETCH_LIST_REQUESTS = 'FETCH_LIST_REQUESTS'
export const LOADING_LIST_REQUESTS = 'LOADING_LIST_REQUESTS'
export const GET_OVERVIEW_REQUESTS = 'GET_OVERVIEW_REQUESTS'
export const GET_REQUEST_DETAIL = 'GET_REQUEST_DETAIL'
export const LOADING_REQUEST_DETAIL = 'LOADING_REQUEST_DETAIL'
export const CLEAR_REQUEST_DETAIL = 'CLEAR_REQUEST_DETAIL'
export const LOADING_PREVIEW_LIST_INVESTMENT = 'LOADING_PREVIEW_LIST_INVESTMENT'
export const GET_PREVIEW_LIST_INVESTMENT = 'GET_PREVIEW_LIST_INVESTMENT'
export const CREATE_CMC_CONTRACT = 'CREATE_CMC_CONTRACT'